import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'glamor'

import { useTheme } from '../../theme'

export const Code: React.FC = props => {
  const theme = useTheme()

  return (
    <code
      {...css({
        fontFamily: theme.settings.typography.fontFamilies.monospace,
        backgroundColor: theme.colors.backgrounds.mainFocus,

        color: theme.colors.accents.negativeActive,
        padding: '3px',
        borderRadius: theme.settings.borderRadiuses.regular,

        'pre > &': {
          color: 'inherit',
          padding: theme.settings.spacing.medium,
          display: 'block',
        },
      })}
    >
      {props.children}
    </code>
  )
}

Code.propTypes = {
  children: PropTypes.node,
}
